function showPopup() {
    $(".popup").addClass('show');
}

function hidePopup() {
    $(".popup").removeClass('show').addClass('hide');
}

function isPopupClosed() {
    return sessionStorage.getItem('popupClosed') === 'true' ? true : false;
}

function isOnPageEnd() {
    return $(window).scrollTop() + $(window).height() > $(document).height();
}

(function () {

    setTimeout(function () {
        if (!isPopupClosed()) {
            showPopup();
        }
    }, 1500);

    $("#close-button").click(function () {
        sessionStorage.setItem('popupClosed', 'true');
        hidePopup();
    });

    window.addEventListener('scroll', function () {
        if(isOnPageEnd()) {
            hidePopup();
        } else if (!isPopupClosed()){
            showPopup();
        }
    });

})();
